var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input-contact__item",attrs:{"type":_vm.type,"name":_vm.name,"placeholder":_vm.placeholder,"required":_vm.isRequired},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }